import { createRouter, createWebHistory, isNavigationFailure, NavigationFailureType } from 'vue-router'
import Home from '@/components/home'

const baseRoutes = [
  {
    path: '/',
    name: 'root',
    component: Home,
    props: { type: 'home' }
  },
  {
    path: '/login',
    name: 'login',
    component: Home,
    props: { type: 'login' }
  },
  {
    // Catch-all: matches any path while dynamic routes are not yet registered
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: Home,
    props: { type: 'home' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.CONTEXT_PATH),
  routes: baseRoutes,
  linkActiveClass: 'link-active',
  linkExactActiveClass: 'link-exact-active'
})

// Remove all dynamically added routes, keep only base routes (including catch-all)
const resetRouter = () => {
  const baseRouteNames = new Set(baseRoutes.map(r => r.name))
  router.getRoutes()
    .filter(r => !baseRouteNames.has(r.name))
    .forEach(r => router.removeRoute(r.name))
}

// Suppress "No match found" warnings during initial load while dynamic routes are not yet registered
const originalPush = router.push.bind(router)
router.push = (...args) => originalPush(...args).catch(err => {
  if (!isNavigationFailure(err, NavigationFailureType.notFound)) throw err
})

export { router, resetRouter }
